import { useRef, useState } from 'react';
import { useInterval } from 'react-use';
import { convertSecondsToTime } from 'utils/timeHelper';

import { useCreateTracker } from './useCreateTracker';
import { deleteActionTimeTracker } from './api';

import type { RefObject } from 'react';

interface UseTrackerResult {
  time: string;
  secondsRef: RefObject<number>;
  start: () => void;
  stop: () => void;
  createTrackerLoading: boolean;
  trackerGuid: string | null;
  deleteTracker: () => void;
  resume: () => void;
}

export const useTracker = (): UseTrackerResult => {
  const secondsRef = useRef<number>(0);
  const [time, setTime] = useState<string>(convertSecondsToTime(0));

  const [delay, setDelay] = useState<number | null>(null);
  const [trackerGuid, setTrackerGuid] = useState<string | null>(null);

  const { createTracker, createTrackerLoading } = useCreateTracker({
    setTrackerGuid,
    setSeconds: (newSeconds) => {
      secondsRef.current = newSeconds;
      setTime(convertSecondsToTime(secondsRef.current));
      setDelay(1000);
    },
  });

  useInterval(() => {
    secondsRef.current += 1;
    setTime(convertSecondsToTime(secondsRef.current));
  }, delay);

  const stop = () => {
    setDelay(null);
  };
  const start = () => {
    const startTime = new Date();
    createTracker(startTime);
    secondsRef.current = 0;
    setTime(convertSecondsToTime(secondsRef.current));
    setDelay(1000);
  };

  const resume = () => {
    setDelay(1000);
  };

  const deleteTracker = () => {
    if (trackerGuid) {
      deleteActionTimeTracker(trackerGuid);
    }
  };

  return {
    time,
    secondsRef,
    start,
    resume,
    stop,
    createTrackerLoading,
    trackerGuid,
    deleteTracker,
  };
};
